module.exports = __webpack_public_path__ + "static/media/store-level-4.ded9aa4e.png";